import Domen from '../../../stores/Domen';
import GlobalState, {
    changesegmentationpagecenter2, 
    changePortraitsheduledeployname,
    changePortraitsheduledeploycred} from '../../../stores/GlobalState';

export async function PostLinkOutlineBigNoSchedule(setNameDatasetprew, setNameDatasetprew2, setTypeDeploy, setTextloadingcompleatedexport) {
    changesegmentationpagecenter2(2);
    setTextloadingcompleatedexport("BigQuery one-time export <br/>was successful");

    const token = localStorage.getItem("token");

    const product = {
        name: "test", // Якщо потрібно динамічне — передай параметром
        table: GlobalState.portraitsheduledeployname2,
        credentials: GlobalState.portraitsheduledeploycred,
    };

    const response = await fetch(`${Domen.url}portraits/table/deploy/biguery`, {
        method: 'POST',
        headers: {
            'Authorization': token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(product),
    });

    if (response.status >= 200 && response.status < 400) {
        changesegmentationpagecenter2(3);
        changePortraitsheduledeployname("");
        changePortraitsheduledeploycred([]);
        setNameDatasetprew("");
        setNameDatasetprew2("");

        setTimeout(() => {
            changesegmentationpagecenter2(1);
            setTypeDeploy(0);
        }, 2000);
    } else {
        changesegmentationpagecenter2(5);
    }
}
